// import { useState, useEffect, useCallback, useRef } from "react";
// import moment from "moment";
// import { Typography, Stack } from "@mui/material";
// import { Popup, Button } from "gf-ui-components-mui-lib";

// const popupStyles = {
//   position: "fixed",
//   top: "50px",
//   left: "50%",
//   transform: "translateX(-50%)",
//   bgcolor: "background.paper",
//   border: "none",
//   borderRadius: "4px",
//   overflow: "hidden",
//   boxSizing: "border-box",
//   width: "300px",
//   height: "150px",
//   ["&:focus"]: {
//     border: "none",
//     outline: "none",
//   },
// };

// const SESSION_TIMEOUT = process.env.REACT_APP_SESSION_TIMEOUT;

// const SessionTimeout = () => {
//   const [events, setEvents] = useState(["click", "load", "scroll"]);
//   const [second, setSecond] = useState(0);
//   const [isOpen, setOpen] = useState(false);

//   const isAuthenticated = localStorage.getItem("access_token");
//   const logout = () => {
//     localStorage.removeItem("access_token");
//     localStorage.removeItem("expires_in");
//     localStorage.removeItem("scope");
//     localStorage.removeItem('xsm_user_details');
//     localStorage.removeItem('username');
//     localStorage.removeItem('permissions');
//     // dispatch(setUserSession(false));
//     window.location.href = "/";
//   };

//   let timeStamp;
//   let warningInactiveInterval = useRef<any>();
//   let startTimerInterval = useRef<any>();

//   let timeChecker = () => {
//     console.log("time checker");
//     startTimerInterval.current = setTimeout(() => {
//       let storedTimeStamp = sessionStorage.getItem("lastTimeStamp");
//       warningInactive(storedTimeStamp);
//     }, 60000);
//   };

//   let warningInactive = (timeString: any) => {
//     console.log({timeString});
//     clearTimeout(startTimerInterval.current);
//     console.log(startTimerInterval.current);
//     console.log(warningInactiveInterval.current);
//     warningInactiveInterval.current = setInterval(() => {
//       const maxTime = 2;
//       const popTime = 1;
//       console.log("this twoo");
//       const diff = moment.duration(moment().diff(moment(timeString)));
//       const minPast = diff.minutes();
//       const leftSecond = 60 - diff.seconds();
//       console.log({diff,maxTime, popTime, minPast, leftSecond});

//       if (minPast === popTime) {
//         setSecond(leftSecond);
//         setOpen(true);
//       }

//       if (minPast === maxTime) {
//         clearInterval(warningInactiveInterval.current);
//         setOpen(false);
//         sessionStorage.removeItem("lastTimeStamp");
//         logout();
//       }
//     }, (SESSION_TIMEOUT as any) * 60 * 1000 || 3600000);
//     // }, 600);
//     console.log(warningInactiveInterval.current);
//   };

//   let resetTimer = useCallback(() => {
//     clearTimeout(startTimerInterval.current);
//     clearInterval(warningInactiveInterval.current);

//     if (isAuthenticated) {
//       timeStamp = moment();
//       sessionStorage.setItem("lastTimeStamp", timeStamp as any);
//     } else {
//       clearInterval(warningInactiveInterval.current);
//       sessionStorage.removeItem("lastTimeStamp");
//     }
//     timeChecker();
//     setOpen(false);
//   }, [isAuthenticated]);

//   const handleClose = () => {
//     setOpen(false);

//     resetTimer();
//   };

//   useEffect(() => {
//     console.log("this one")
//     events.forEach((event) => {
//       window.addEventListener(event, resetTimer);
//     });

//     timeChecker();

//     return () => {
//       clearTimeout(startTimerInterval.current);
//       //   resetTimer();
//     };
//   }, [resetTimer, events, timeChecker]);

//   if (!isOpen) {
//     return null;
//   }

//   return (
//     <Popup id="adapter-customize" sx={popupStyles} isOpen>
//       <Stack direction="column" gap={2} p={3}>
//         <Typography>
//           User session timeout, redirecting to login page.
//         </Typography>
//         <Button onClick={logout} variant="contained">
//           Okay
//         </Button>
//       </Stack>
//     </Popup>
//   );
// };

// export default SessionTimeout;

// I haven't removed the old code for the backup purpose
import { useState, useEffect, useCallback, useRef } from 'react';
import moment from 'moment';
import { Typography, Stack } from '@mui/material';
import { Popup, Button } from 'gf-ui-components-mui-lib';
import { decodeJwtWithJsrs } from '@utils/helpers';
import { refreshAccessToken, REFRESH_THRESHOLD_MS } from '@utils/tokenRefresh';

const popupStyles = {
  position: 'fixed',
  top: '50px',
  left: '50%',
  transform: 'translateX(-50%)',
  bgcolor: 'background.paper',
  border: 'none',
  borderRadius: '4px',
  overflow: 'hidden',
  boxSizing: 'border-box',
  width: '300px',
  height: '150px',
  ['&:focus']: {
    border: 'none',
    outline: 'none',
  },
};

const LOGOUT_URL = process.env.REACT_APP_XSM_PRODUCT_URL as string;
const REFRESH_INTERVAL = REFRESH_THRESHOLD_MS;

const SessionTimeout = () => {
  const [isOpen, setOpen] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const isAuthenticated = localStorage.getItem('access_token');
  const logout = () => {
    localStorage.clear();
    window.location.href = LOGOUT_URL;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getExpirationTime = () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      return null;
    }
    try {
      const decodedToken = decodeJwtWithJsrs(token);
      return decodedToken.exp * 1000;
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };

  const refreshAccessTokenSilently = useCallback(async () => {
    // Only block duplicate calls while a refresh is already in progress
    if (isRefreshing) {
      return;
    }
    setIsRefreshing(true);
    try {
      const refreshed = await refreshAccessToken();
      if (!refreshed) {
        // Show the timeout popup only when refresh fails and the user is inactive
        if (!isActive) {
          setOpen(true);
        }
      }
    } finally {
      setIsRefreshing(false);
    }
  }, [isRefreshing, isActive]);

  let warningInactiveInterval = useRef<any>();

  let warningInactive = useCallback(() => {
    const expirationTime = getExpirationTime();
    if (!expirationTime) {
      return;
    }

    const currentTime = moment().valueOf();
    const remainingTime = expirationTime - currentTime;
    if (remainingTime <= 0) {
      if (isActive) {
        // Active users get a silent refresh instead of a blocking popup
        refreshAccessTokenSilently();
      } else {
        // Inactive users are prompted only after the token has actually expired
        setOpen(true);
      }
    }
  }, [getExpirationTime, isActive, refreshAccessTokenSilently]);

  let resetTimer = useCallback(() => {
    clearInterval(warningInactiveInterval.current);

    if (isAuthenticated) {
      warningInactiveInterval.current = setInterval(() => {
        warningInactive();
      }, 1000);
    }
  }, [isAuthenticated, warningInactive]);

  const handleClose = () => {
    setOpen(false);
    resetTimer();
  };

  useEffect(() => {
    const expirationTime = getExpirationTime();

    if (isAuthenticated && expirationTime) {
      warningInactiveInterval.current = setInterval(() => {
        warningInactive();
      }, 1000);
    }

    const refreshIntervalId = setInterval(() => {
      if (isActive) {
        // Calculate time left until expiration
        const expirationTime = getExpirationTime();
        if (expirationTime) {
          const currentTime = moment().valueOf();
          const remainingTime = expirationTime - currentTime;
          // Refresh token 5 minutes before expiration when the user is active
          if (remainingTime > 0 && remainingTime <= REFRESH_INTERVAL) {
            refreshAccessTokenSilently();
          }
        }
      } else {
        console.log('Inactive state');
      }
    }, 1000);

    return () => {
      clearInterval(warningInactiveInterval.current);
      clearInterval(refreshIntervalId);
    };
  }, [isAuthenticated, isActive, warningInactive, refreshAccessTokenSilently]);

  // Effect for detecting page visibility
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    };

    // Add event listener for visibility change
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <Popup id='adapter-customize' sx={popupStyles} isOpen>
      <Stack direction='column' gap={2} p={3}>
        <Typography>
          User session timeout, redirecting to the login page.
        </Typography>
        <Button
          onClick={logout}
          variant='contained'
          sx={{
            backgroundColor: '#1976d2 !important',
          }}
        >
          Okay
        </Button>
      </Stack>
    </Popup>
  );
};

export default SessionTimeout;
